var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"modules budget staffing-table components Btn",attrs:{"disabled":_vm.disabled},on:{"click":_vm.onClick}},[_vm._t("default",function(){return [_vm._v(" "+_vm._s(_vm.text)+" ")]})],2)}
var staticRenderFns = []

export { render, staticRenderFns }